module.exports = __webpack_public_path__ + "static/media/squared.713d707a.jpg";